import { render, staticRenderFns } from "./VineyardGasMetricTable.vue?vue&type=template&id=5d6f56a8&scoped=true&"
import script from "./VineyardGasMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardGasMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f56a8",
  null
  
)

export default component.exports